export default __webpack_public_path__ + "static/media/MAYDOM2025.7008d450.png";